import React, { ReactNode, useMemo } from 'react'
import { Icon } from 'semantic-ui-react'
import usePlayerActions from '../../hooks/usePlayerActions'
import { useSelector } from '../../../../hooks/useSelector'
import PromiseMenuItem from '../../../../components/PromiseMenuItem'
import formatCost from '../../../../utils/formatCost'
import { createLocUpgradeLevels, truncateCash } from '@prometheus/utils'
import { formatZeros } from './formatZeros'
import { Card, Cards, Popup, Stack, Typography } from '@prometheus/components'
import PromiseCard from '@/components/PromiseCard'

interface LOCMaxUpgradesPopupProps {
  children: ReactNode
}

export default ({ children }: LOCMaxUpgradesPopupProps) => {
  const _loc_max_upgrades = useSelector(s => s.game.options?.loc_max_upgrades) || []
  const loc = useSelector(s => s.game.sheet?.loc)
  const level = loc?.max_level
  const bonuses = (loc?.max_bonuses || 0)
  const {
    onUpgrade,
  } = usePlayerActions()
  if (typeof level !== 'number') {
    return null
  }

  const __loc_max_upgrades = useMemo(() => {
    return createLocUpgradeLevels(_loc_max_upgrades)
  }, [_loc_max_upgrades])

  const loc_max_upgrades = useMemo(() => {
    return __loc_max_upgrades.slice(Math.max(level, 0), level + 6)
  }, [__loc_max_upgrades, level])

  return (
    <Popup hoverable position="left center" trigger={children}>
      <Card padding="sm" style={{ width: 'min(400px, calc(100vw - 20px))' }}>
        <Stack>
          <Typography variant="h4">LOC Max Withdrawal Upgrades <Typography variant="h4" component="span" color="secondary">Level {level + 1}</Typography></Typography>
          <Cards>
            {loc_max_upgrades.map(({ cost, max }, i) => {
              const disabled = i >= 2
              const isNextUpgrade = i === 1
              const isUpgraded = i < 1
              let color: string | undefined = undefined;
              if (isUpgraded) color = 'var(--prometheus-secondary)'
              else if (disabled) color = 'var(--prometheus-gray-500)'
              let onClick
              if (isNextUpgrade) {
                onClick = () => onUpgrade('loc_max')
              }
              return (
                <PromiseCard key={max} padding="sm" interactive ignoreGameLogic disabled={disabled} onClick={onClick}>
                  <Stack direction="row" style={{ justifyContent: 'space-between' }}>
                    <Typography bold style={{ color }}>Level {level + i + 1} | Max Withdraw: {truncateCash(max + (bonuses || 0))}</Typography>
                    {isNextUpgrade && (<Icon name="angle double up" style={{ color: 'var(--prometheus-primary)' }} size="large" />)}
                    {isUpgraded && (<Icon name="check square" style={{ color: 'var(--prometheus-secondary' }} size="large" />)}
                  </Stack>
                  <Typography style={{ color }}>{formatCost(cost)}</Typography>
                </PromiseCard>
              )
            })}
          </Cards>
        </Stack>
      </Card>
    </Popup>
  )
}
